import Typo from '@/ui/typo/Typo';
import { COLORS } from '@/styles/colorTheme';
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react';
import { Fragment } from 'react';

const EsgTopicPopup = ({ title, desc, isOpen = false, closeModal, category }) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative" onClose={closeModal}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" style={{ zIndex: 1000 }} />
        </TransitionChild>

        <div className="fixed inset-0 overflow-y-auto" style={{ zIndex: 1000 }}>
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <DialogTitle as="h3" className="text-lg font-medium leading-6 text-gray-900 mb-4">
                  <div>
                    <Typo variant="h2" color={COLORS.Text400}>
                      {title}
                    </Typo>
                  </div>
                  <div>
                    <Typo variant="b3" color={COLORS.Text100}>
                      {category === 'sasb' ? 'SASB Material Topic' : 'Emerging Material Topic'}
                    </Typo>
                  </div>{' '}
                </DialogTitle>

                <Typo variant="b2" color={COLORS.Text300} sx={{ lineHeight: '24px' }}>
                  {desc}
                </Typo>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default EsgTopicPopup;
